module.exports = __webpack_public_path__ + "img/antelope.e9b86811.png";